(function() {
  'use strict';

  if (!document.body.classList.contains('template-product')) return;

  var init = function() {
    var atcBtn = document.querySelector('.add-to-cart, button.add-to-cart, .btn.add-to-cart, button[name="add"], form[data-add-to-cart] button[type="submit"]');
    if (!atcBtn) {
      console.warn('[spx-sticky-atc] no ATC button found');
      return;
    }

    var form = atcBtn.closest('form') || document.querySelector('form[action="/cart/add"], form[data-add-to-cart]');
    if (!form) {
      console.warn('[spx-sticky-atc] no form found');
      return;
    }

    var titleEl = document.querySelector('h1.product__title, h1[itemprop="name"], .product__title, h1');
    var title = titleEl ? titleEl.textContent.trim() : 'Product';

    var priceEl = document.querySelector('[data-product-price], .product__price, .price__current, .product-price__price, .price-item--regular');
    var price = priceEl ? priceEl.textContent.trim() : '';

    // Build sticky bar with variant selector
    var bar = document.createElement('div');
    bar.className = 'spx-sticky-atc';
    bar.innerHTML =
      '<div class="spx-sticky-atc__info">' +
        '<div class="spx-sticky-atc__title"></div>' +
        '<div class="spx-sticky-atc__variant">' +
          '<select class="spx-sticky-atc__variant-select" aria-label="Select variant"></select>' +
        '</div>' +
        '<div class="spx-sticky-atc__price"></div>' +
      '</div>' +
      '<button type="button" class="spx-sticky-atc__btn">Add to cart</button>';
    document.body.appendChild(bar);

    var titleSlot = bar.querySelector('.spx-sticky-atc__title');
    var priceSlot = bar.querySelector('.spx-sticky-atc__price');
    var variantSelect = bar.querySelector('.spx-sticky-atc__variant-select');
    var btn = bar.querySelector('.spx-sticky-atc__btn');

    titleSlot.textContent = title;
    priceSlot.textContent = price;

    // Populate variant select from the actual product form
    var variantJsonScript = document.querySelector('script[type="application/json"][data-variants], script#ProductJson, script[type="application/json"]#ProductJson-product, script#ProductJson-product-template');
    var variants = [];
    if (variantJsonScript) {
      try {
        var data = JSON.parse(variantJsonScript.textContent);
        variants = data.variants || (data.product && data.product.variants) || [];
      } catch (e) {
        console.warn('[spx-sticky-atc] failed to parse variants JSON');
      }
    }

    // Fallback: read from the original form's <select name="id"> if it exists
    if (!variants.length) {
      var origSelect = form.querySelector('select[name="id"]');
      if (origSelect) {
        Array.from(origSelect.options).forEach(function(opt) {
          if (opt.value && opt.value !== '') {
            variants.push({
              id: opt.value,
              title: opt.textContent.trim(),
              available: !opt.disabled,
              price: ''
            });
          }
        });
      }
    }

    if (variants.length > 1) {
      variants.forEach(function(v) {
        var opt = document.createElement('option');
        opt.value = v.id;
        opt.textContent = v.title + (v.available === false ? ' — Sold out' : '');
        if (v.available === false) opt.disabled = true;
        variantSelect.appendChild(opt);
      });

      // Sync sticky select to original form's current variant
      var syncVariant = function() {
        var origSelect = form.querySelector('select[name="id"], input[name="id"]');
        var currentId = '';
        if (origSelect) {
          currentId = origSelect.value || '';
        }
        if (currentId) {
          variantSelect.value = currentId;
        }
      };
      syncVariant();

      // When sticky select changes, update original form + page UI
      variantSelect.addEventListener('change', function() {
        var origSelect = form.querySelector('select[name="id"]');
        if (origSelect) {
          origSelect.value = variantSelect.value;
          origSelect.dispatchEvent(new Event('change', { bubbles: true }));
        }
        var radioInputs = form.querySelectorAll('input[type="radio"][name="id"], input[type="radio"][data-index]');
        radioInputs.forEach(function(r) {
          if (r.value === variantSelect.value) {
            r.checked = true;
            r.dispatchEvent(new Event('change', { bubbles: true }));
          }
        });
      });

      // When page variant changes (user clicks size swatch), update sticky
      form.addEventListener('change', function(e) {
        if (e.target.matches('select[name="id"], input[name="id"], input[type="radio"][name="id"]')) {
          syncVariant();
          setTimeout(function() {
            var newPrice = document.querySelector('[data-product-price], .product__price, .price__current, .product-price__price');
            if (newPrice) priceSlot.textContent = newPrice.textContent.trim();
          }, 100);
        }
      });
    } else {
      // Only one variant — hide the select
      bar.querySelector('.spx-sticky-atc__variant').style.display = 'none';
    }

    console.log('[spx-sticky-atc] initialized for:', title, price, '(' + variants.length + ' variants)');

    // ---------------------------------------------------------------------
    // Drawer detection — hide the sticky bar whenever ANY Impulse drawer is
    // open (cart, mobile nav, search, filter, etc.).
    //
    // Three reliable signals fire on open, in priority order:
    //   1. CustomEvent "drawerOpen" dispatched on document by theme.Drawers
    //      (cleared by "drawerClose" — but close isn't dispatched in v8, so
    //      we re-check state on every close signal)
    //   2. <html> gets .js-drawer-open added (theme sets it on open)
    //   3. Each .drawer gets .drawer--is-open (NOT .is-open — that was the bug)
    //   4. Trigger button gets aria-expanded="true"
    //
    // We track open state via a counter so multiple drawers (theoretically)
    // can't desync, then update on every signal. Re-check the truth on every
    // event rather than trust any single signal.
    // ---------------------------------------------------------------------
    var openCount = 0;
    var bumpOpen = function(delta) {
      openCount = Math.max(0, openCount + delta);
      if (openCount > 0) {
        document.body.classList.add('spx-drawer-open');
      } else {
        document.body.classList.remove('spx-drawer-open');
      }
      update();
    };

    // Signal 1: theme's CustomEvent — most authoritative.
    document.addEventListener('drawerOpen', function() { bumpOpen(+1); });
    // theme.Drawers does NOT dispatch "drawerClose" in this version. It removes
    // the .drawer--is-open class and .js-drawer-open class. We rely on the
    // mutation observers below to catch close.

    // Signal 2: <html> class flip.
    var htmlObserver = new MutationObserver(function(muts) {
      for (var i = 0; i < muts.length; i++) {
        var cls = document.documentElement.className;
        if (cls.indexOf('js-drawer-open') !== -1) {
          // Only bump if we don't already count this as open.
          if (!document.body.classList.contains('spx-drawer-open')) bumpOpen(+1);
        } else {
          // html lost the class — recompute from scratch (safer than decrementing).
          recomputeDrawerState();
        }
      }
    });
    htmlObserver.observe(document.documentElement, { attributes: true, attributeFilter: ['class'] });

    // Signal 3: each drawer's class flip.
    var drawerObserver = new MutationObserver(function(muts) {
      // Any drawer's classlist changed → recompute.
      recomputeDrawerState();
    });

    // Signal 4: aria-expanded on trigger buttons.
    var triggerObserver = new MutationObserver(function(muts) {
      recomputeDrawerState();
    });

    // Compute truth from the DOM directly. Cheap (1ms).
    var recomputeDrawerState = function() {
      var drawers = document.querySelectorAll('.drawer.drawer--is-open');
      var triggers = document.querySelectorAll('.js-drawer-open-cart[aria-expanded="true"], .js-drawer-open-nav[aria-expanded="true"], .js-drawer-open-search[aria-expanded="true"], .js-drawer-open-filter[aria-expanded="true"], .js-drawer-open-collection-filters[aria-expanded="true"]');
      var htmlOpen = document.documentElement.className.indexOf('js-drawer-open') !== -1;
      var anyOpen = drawers.length > 0 || triggers.length > 0 || htmlOpen;
      if (anyOpen) {
        if (openCount < 1) openCount = 1;
        document.body.classList.add('spx-drawer-open');
      } else {
        openCount = 0;
        document.body.classList.remove('spx-drawer-open');
      }
      update();
    };

    // Attach observers to any drawer we can find now, plus re-scan after
    // the DOM settles (some app blocks lazy-load drawers after init).
    var attachObservers = function() {
      document.querySelectorAll('.drawer').forEach(function(d) {
        drawerObserver.observe(d, { attributes: true, attributeFilter: ['class'] });
      });
      document.querySelectorAll('.js-drawer-open-cart, .js-drawer-open-nav, .js-drawer-open-search, .js-drawer-open-filter, .js-drawer-open-collection-filters').forEach(function(t) {
        triggerObserver.observe(t, { attributes: true, attributeFilter: ['aria-expanded', 'class'] });
      });
    };
    attachObservers();
    setTimeout(attachObservers, 1500);
    setTimeout(attachObservers, 4000);

    // Show/hide on scroll. Also hide whenever any drawer is open.
    var ticking = false;
    var update = function() {
      var drawerOpen = document.body.classList.contains('spx-drawer-open');
      var rect = atcBtn.getBoundingClientRect();
      var inView = rect.top < window.innerHeight - 50 && rect.bottom > 100;
      if (inView || drawerOpen) {
        bar.classList.remove('spx-sticky-atc--visible');
        document.body.classList.remove('spx-sticky-atc-padding');
      } else {
        bar.classList.add('spx-sticky-atc--visible');
        document.body.classList.add('spx-sticky-atc-padding');
      }
      ticking = false;
    };

    window.addEventListener('scroll', function() {
      if (!ticking) {
        window.requestAnimationFrame(update);
        ticking = true;
      }
    }, { passive: true });
    window.addEventListener('resize', update);
    update();

    // Click handler — submit form with selected variant
    btn.addEventListener('click', function(e) {
      e.preventDefault();
      // Sync the variant selection back to the original form before submit
      if (variantSelect.value) {
        var origSelect = form.querySelector('select[name="id"]');
        if (origSelect && origSelect.value !== variantSelect.value) {
          origSelect.value = variantSelect.value;
          origSelect.dispatchEvent(new Event('change', { bubbles: true }));
        }
        var radios = form.querySelectorAll('input[type="radio"][name="id"]');
        radios.forEach(function(r) {
          if (r.value === variantSelect.value) r.checked = true;
        });
      }
      console.log('[spx-sticky-atc] click — submitting form');
      var submitEvent = new Event('submit', { bubbles: true, cancelable: true });
      form.dispatchEvent(submitEvent);
      if (!submitEvent.defaultPrevented) {
        atcBtn.click();
      }
    });
  };

  var tries = 0;
  var tryInit = function() {
    tries++;
    if (document.querySelector('.add-to-cart')) {
      init();
    } else if (tries < 20) {
      setTimeout(tryInit, 250);
    } else {
      console.warn('[spx-sticky-atc] gave up after 20 tries');
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() { setTimeout(tryInit, 100); });
  } else {
    setTimeout(tryInit, 100);
  }
})();